import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeContext } from './contexts/ThemeContext';
import { Main, BlogPage, ProjectPage } from './pages'
import { BackToTop } from './components'
import ScrollToTop from './utils/ScrollToTop'
import './App.css'
function App() {
  const { theme } = useContext(ThemeContext);
  console.log("%Manav Mangukiya Portfolio", `color:${theme.primary}; font-size:50px`);

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Main />} />
          <Route path='/projects' element={<ProjectPage />} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </Router>
      <BackToTop />
    </div>
  );
}

export default App;
